function parseDate(input, format) {
  format = format || 'yyyy-mm-dd'; // default format
  var parts = input.match(/(\d+)/g),
      i = 0, fmt = {};
  // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

  return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
}

function obtenirRutaBase() {
    var pathname = $(location).attr("pathname");;
    // Utilitzar una expressió regular per eliminar qualsevol cosa a partir de '/ca' o '/es'
    var rutaNeta = pathname.replace(/\/(ca|es|bop|dashboard|anuncis|admin)\/.*/, '');
    return rutaNeta;
}

$(document).ready(function(){

    $('.select2').select2();

    var DIACRITICS = {
            '\u24B6': 'A',
            '\uFF21': 'A',
            '\u00C0': 'A',
            '\u00C1': 'A',
            '\u00C2': 'A',
            '\u1EA6': 'A',
            '\u1EA4': 'A',
            '\u1EAA': 'A',
            '\u1EA8': 'A',
            '\u00C3': 'A',
            '\u0100': 'A',
            '\u0102': 'A',
            '\u1EB0': 'A',
            '\u1EAE': 'A',
            '\u1EB4': 'A',
            '\u1EB2': 'A',
            '\u0226': 'A',
            '\u01E0': 'A',
            '\u00C4': 'A',
            '\u01DE': 'A',
            '\u1EA2': 'A',
            '\u00C5': 'A',
            '\u01FA': 'A',
            '\u01CD': 'A',
            '\u0200': 'A',
            '\u0202': 'A',
            '\u1EA0': 'A',
            '\u1EAC': 'A',
            '\u1EB6': 'A',
            '\u1E00': 'A',
            '\u0104': 'A',
            '\u023A': 'A',
            '\u2C6F': 'A',
            '\uA732': 'AA',
            '\u00C6': 'AE',
            '\u01FC': 'AE',
            '\u01E2': 'AE',
            '\uA734': 'AO',
            '\uA736': 'AU',
            '\uA738': 'AV',
            '\uA73A': 'AV',
            '\uA73C': 'AY',
            '\u24B7': 'B',
            '\uFF22': 'B',
            '\u1E02': 'B',
            '\u1E04': 'B',
            '\u1E06': 'B',
            '\u0243': 'B',
            '\u0182': 'B',
            '\u0181': 'B',
            '\u24B8': 'C',
            '\uFF23': 'C',
            '\u0106': 'C',
            '\u0108': 'C',
            '\u010A': 'C',
            '\u010C': 'C',
            '\u00C7': 'C',
            '\u1E08': 'C',
            '\u0187': 'C',
            '\u023B': 'C',
            '\uA73E': 'C',
            '\u24B9': 'D',
            '\uFF24': 'D',
            '\u1E0A': 'D',
            '\u010E': 'D',
            '\u1E0C': 'D',
            '\u1E10': 'D',
            '\u1E12': 'D',
            '\u1E0E': 'D',
            '\u0110': 'D',
            '\u018B': 'D',
            '\u018A': 'D',
            '\u0189': 'D',
            '\uA779': 'D',
            '\u01F1': 'DZ',
            '\u01C4': 'DZ',
            '\u01F2': 'Dz',
            '\u01C5': 'Dz',
            '\u24BA': 'E',
            '\uFF25': 'E',
            '\u00C8': 'E',
            '\u00C9': 'E',
            '\u00CA': 'E',
            '\u1EC0': 'E',
            '\u1EBE': 'E',
            '\u1EC4': 'E',
            '\u1EC2': 'E',
            '\u1EBC': 'E',
            '\u0112': 'E',
            '\u1E14': 'E',
            '\u1E16': 'E',
            '\u0114': 'E',
            '\u0116': 'E',
            '\u00CB': 'E',
            '\u1EBA': 'E',
            '\u011A': 'E',
            '\u0204': 'E',
            '\u0206': 'E',
            '\u1EB8': 'E',
            '\u1EC6': 'E',
            '\u0228': 'E',
            '\u1E1C': 'E',
            '\u0118': 'E',
            '\u1E18': 'E',
            '\u1E1A': 'E',
            '\u0190': 'E',
            '\u018E': 'E',
            '\u24BB': 'F',
            '\uFF26': 'F',
            '\u1E1E': 'F',
            '\u0191': 'F',
            '\uA77B': 'F',
            '\u24BC': 'G',
            '\uFF27': 'G',
            '\u01F4': 'G',
            '\u011C': 'G',
            '\u1E20': 'G',
            '\u011E': 'G',
            '\u0120': 'G',
            '\u01E6': 'G',
            '\u0122': 'G',
            '\u01E4': 'G',
            '\u0193': 'G',
            '\uA7A0': 'G',
            '\uA77D': 'G',
            '\uA77E': 'G',
            '\u24BD': 'H',
            '\uFF28': 'H',
            '\u0124': 'H',
            '\u1E22': 'H',
            '\u1E26': 'H',
            '\u021E': 'H',
            '\u1E24': 'H',
            '\u1E28': 'H',
            '\u1E2A': 'H',
            '\u0126': 'H',
            '\u2C67': 'H',
            '\u2C75': 'H',
            '\uA78D': 'H',
            '\u24BE': 'I',
            '\uFF29': 'I',
            '\u00CC': 'I',
            '\u00CD': 'I',
            '\u00CE': 'I',
            '\u0128': 'I',
            '\u012A': 'I',
            '\u012C': 'I',
            '\u0130': 'I',
            '\u00CF': 'I',
            '\u1E2E': 'I',
            '\u1EC8': 'I',
            '\u01CF': 'I',
            '\u0208': 'I',
            '\u020A': 'I',
            '\u1ECA': 'I',
            '\u012E': 'I',
            '\u1E2C': 'I',
            '\u0197': 'I',
            '\u24BF': 'J',
            '\uFF2A': 'J',
            '\u0134': 'J',
            '\u0248': 'J',
            '\u24C0': 'K',
            '\uFF2B': 'K',
            '\u1E30': 'K',
            '\u01E8': 'K',
            '\u1E32': 'K',
            '\u0136': 'K',
            '\u1E34': 'K',
            '\u0198': 'K',
            '\u2C69': 'K',
            '\uA740': 'K',
            '\uA742': 'K',
            '\uA744': 'K',
            '\uA7A2': 'K',
            '\u24C1': 'L',
            '\uFF2C': 'L',
            '\u013F': 'L',
            '\u0139': 'L',
            '\u013D': 'L',
            '\u1E36': 'L',
            '\u1E38': 'L',
            '\u013B': 'L',
            '\u1E3C': 'L',
            '\u1E3A': 'L',
            '\u0141': 'L',
            '\u023D': 'L',
            '\u2C62': 'L',
            '\u2C60': 'L',
            '\uA748': 'L',
            '\uA746': 'L',
            '\uA780': 'L',
            '\u01C7': 'LJ',
            '\u01C8': 'Lj',
            '\u24C2': 'M',
            '\uFF2D': 'M',
            '\u1E3E': 'M',
            '\u1E40': 'M',
            '\u1E42': 'M',
            '\u2C6E': 'M',
            '\u019C': 'M',
            '\u24C3': 'N',
            '\uFF2E': 'N',
            '\u01F8': 'N',
            '\u0143': 'N',
            '\u00D1': 'N',
            '\u1E44': 'N',
            '\u0147': 'N',
            '\u1E46': 'N',
            '\u0145': 'N',
            '\u1E4A': 'N',
            '\u1E48': 'N',
            '\u0220': 'N',
            '\u019D': 'N',
            '\uA790': 'N',
            '\uA7A4': 'N',
            '\u01CA': 'NJ',
            '\u01CB': 'Nj',
            '\u24C4': 'O',
            '\uFF2F': 'O',
            '\u00D2': 'O',
            '\u00D3': 'O',
            '\u00D4': 'O',
            '\u1ED2': 'O',
            '\u1ED0': 'O',
            '\u1ED6': 'O',
            '\u1ED4': 'O',
            '\u00D5': 'O',
            '\u1E4C': 'O',
            '\u022C': 'O',
            '\u1E4E': 'O',
            '\u014C': 'O',
            '\u1E50': 'O',
            '\u1E52': 'O',
            '\u014E': 'O',
            '\u022E': 'O',
            '\u0230': 'O',
            '\u00D6': 'O',
            '\u022A': 'O',
            '\u1ECE': 'O',
            '\u0150': 'O',
            '\u01D1': 'O',
            '\u020C': 'O',
            '\u020E': 'O',
            '\u01A0': 'O',
            '\u1EDC': 'O',
            '\u1EDA': 'O',
            '\u1EE0': 'O',
            '\u1EDE': 'O',
            '\u1EE2': 'O',
            '\u1ECC': 'O',
            '\u1ED8': 'O',
            '\u01EA': 'O',
            '\u01EC': 'O',
            '\u00D8': 'O',
            '\u01FE': 'O',
            '\u0186': 'O',
            '\u019F': 'O',
            '\uA74A': 'O',
            '\uA74C': 'O',
            '\u0152': 'OE',
            '\u01A2': 'OI',
            '\uA74E': 'OO',
            '\u0222': 'OU',
            '\u24C5': 'P',
            '\uFF30': 'P',
            '\u1E54': 'P',
            '\u1E56': 'P',
            '\u01A4': 'P',
            '\u2C63': 'P',
            '\uA750': 'P',
            '\uA752': 'P',
            '\uA754': 'P',
            '\u24C6': 'Q',
            '\uFF31': 'Q',
            '\uA756': 'Q',
            '\uA758': 'Q',
            '\u024A': 'Q',
            '\u24C7': 'R',
            '\uFF32': 'R',
            '\u0154': 'R',
            '\u1E58': 'R',
            '\u0158': 'R',
            '\u0210': 'R',
            '\u0212': 'R',
            '\u1E5A': 'R',
            '\u1E5C': 'R',
            '\u0156': 'R',
            '\u1E5E': 'R',
            '\u024C': 'R',
            '\u2C64': 'R',
            '\uA75A': 'R',
            '\uA7A6': 'R',
            '\uA782': 'R',
            '\u24C8': 'S',
            '\uFF33': 'S',
            '\u1E9E': 'S',
            '\u015A': 'S',
            '\u1E64': 'S',
            '\u015C': 'S',
            '\u1E60': 'S',
            '\u0160': 'S',
            '\u1E66': 'S',
            '\u1E62': 'S',
            '\u1E68': 'S',
            '\u0218': 'S',
            '\u015E': 'S',
            '\u2C7E': 'S',
            '\uA7A8': 'S',
            '\uA784': 'S',
            '\u24C9': 'T',
            '\uFF34': 'T',
            '\u1E6A': 'T',
            '\u0164': 'T',
            '\u1E6C': 'T',
            '\u021A': 'T',
            '\u0162': 'T',
            '\u1E70': 'T',
            '\u1E6E': 'T',
            '\u0166': 'T',
            '\u01AC': 'T',
            '\u01AE': 'T',
            '\u023E': 'T',
            '\uA786': 'T',
            '\uA728': 'TZ',
            '\u24CA': 'U',
            '\uFF35': 'U',
            '\u00D9': 'U',
            '\u00DA': 'U',
            '\u00DB': 'U',
            '\u0168': 'U',
            '\u1E78': 'U',
            '\u016A': 'U',
            '\u1E7A': 'U',
            '\u016C': 'U',
            '\u00DC': 'U',
            '\u01DB': 'U',
            '\u01D7': 'U',
            '\u01D5': 'U',
            '\u01D9': 'U',
            '\u1EE6': 'U',
            '\u016E': 'U',
            '\u0170': 'U',
            '\u01D3': 'U',
            '\u0214': 'U',
            '\u0216': 'U',
            '\u01AF': 'U',
            '\u1EEA': 'U',
            '\u1EE8': 'U',
            '\u1EEE': 'U',
            '\u1EEC': 'U',
            '\u1EF0': 'U',
            '\u1EE4': 'U',
            '\u1E72': 'U',
            '\u0172': 'U',
            '\u1E76': 'U',
            '\u1E74': 'U',
            '\u0244': 'U',
            '\u24CB': 'V',
            '\uFF36': 'V',
            '\u1E7C': 'V',
            '\u1E7E': 'V',
            '\u01B2': 'V',
            '\uA75E': 'V',
            '\u0245': 'V',
            '\uA760': 'VY',
            '\u24CC': 'W',
            '\uFF37': 'W',
            '\u1E80': 'W',
            '\u1E82': 'W',
            '\u0174': 'W',
            '\u1E86': 'W',
            '\u1E84': 'W',
            '\u1E88': 'W',
            '\u2C72': 'W',
            '\u24CD': 'X',
            '\uFF38': 'X',
            '\u1E8A': 'X',
            '\u1E8C': 'X',
            '\u24CE': 'Y',
            '\uFF39': 'Y',
            '\u1EF2': 'Y',
            '\u00DD': 'Y',
            '\u0176': 'Y',
            '\u1EF8': 'Y',
            '\u0232': 'Y',
            '\u1E8E': 'Y',
            '\u0178': 'Y',
            '\u1EF6': 'Y',
            '\u1EF4': 'Y',
            '\u01B3': 'Y',
            '\u024E': 'Y',
            '\u1EFE': 'Y',
            '\u24CF': 'Z',
            '\uFF3A': 'Z',
            '\u0179': 'Z',
            '\u1E90': 'Z',
            '\u017B': 'Z',
            '\u017D': 'Z',
            '\u1E92': 'Z',
            '\u1E94': 'Z',
            '\u01B5': 'Z',
            '\u0224': 'Z',
            '\u2C7F': 'Z',
            '\u2C6B': 'Z',
            '\uA762': 'Z',
            '\u24D0': 'a',
            '\uFF41': 'a',
            '\u1E9A': 'a',
            '\u00E0': 'a',
            '\u00E1': 'a',
            '\u00E2': 'a',
            '\u1EA7': 'a',
            '\u1EA5': 'a',
            '\u1EAB': 'a',
            '\u1EA9': 'a',
            '\u00E3': 'a',
            '\u0101': 'a',
            '\u0103': 'a',
            '\u1EB1': 'a',
            '\u1EAF': 'a',
            '\u1EB5': 'a',
            '\u1EB3': 'a',
            '\u0227': 'a',
            '\u01E1': 'a',
            '\u00E4': 'a',
            '\u01DF': 'a',
            '\u1EA3': 'a',
            '\u00E5': 'a',
            '\u01FB': 'a',
            '\u01CE': 'a',
            '\u0201': 'a',
            '\u0203': 'a',
            '\u1EA1': 'a',
            '\u1EAD': 'a',
            '\u1EB7': 'a',
            '\u1E01': 'a',
            '\u0105': 'a',
            '\u2C65': 'a',
            '\u0250': 'a',
            '\uA733': 'aa',
            '\u00E6': 'ae',
            '\u01FD': 'ae',
            '\u01E3': 'ae',
            '\uA735': 'ao',
            '\uA737': 'au',
            '\uA739': 'av',
            '\uA73B': 'av',
            '\uA73D': 'ay',
            '\u24D1': 'b',
            '\uFF42': 'b',
            '\u1E03': 'b',
            '\u1E05': 'b',
            '\u1E07': 'b',
            '\u0180': 'b',
            '\u0183': 'b',
            '\u0253': 'b',
            '\u24D2': 'c',
            '\uFF43': 'c',
            '\u0107': 'c',
            '\u0109': 'c',
            '\u010B': 'c',
            '\u010D': 'c',
            '\u00E7': 'c',
            '\u1E09': 'c',
            '\u0188': 'c',
            '\u023C': 'c',
            '\uA73F': 'c',
            '\u2184': 'c',
            '\u24D3': 'd',
            '\uFF44': 'd',
            '\u1E0B': 'd',
            '\u010F': 'd',
            '\u1E0D': 'd',
            '\u1E11': 'd',
            '\u1E13': 'd',
            '\u1E0F': 'd',
            '\u0111': 'd',
            '\u018C': 'd',
            '\u0256': 'd',
            '\u0257': 'd',
            '\uA77A': 'd',
            '\u01F3': 'dz',
            '\u01C6': 'dz',
            '\u24D4': 'e',
            '\uFF45': 'e',
            '\u00E8': 'e',
            '\u00E9': 'e',
            '\u00EA': 'e',
            '\u1EC1': 'e',
            '\u1EBF': 'e',
            '\u1EC5': 'e',
            '\u1EC3': 'e',
            '\u1EBD': 'e',
            '\u0113': 'e',
            '\u1E15': 'e',
            '\u1E17': 'e',
            '\u0115': 'e',
            '\u0117': 'e',
            '\u00EB': 'e',
            '\u1EBB': 'e',
            '\u011B': 'e',
            '\u0205': 'e',
            '\u0207': 'e',
            '\u1EB9': 'e',
            '\u1EC7': 'e',
            '\u0229': 'e',
            '\u1E1D': 'e',
            '\u0119': 'e',
            '\u1E19': 'e',
            '\u1E1B': 'e',
            '\u0247': 'e',
            '\u025B': 'e',
            '\u01DD': 'e',
            '\u24D5': 'f',
            '\uFF46': 'f',
            '\u1E1F': 'f',
            '\u0192': 'f',
            '\uA77C': 'f',
            '\u24D6': 'g',
            '\uFF47': 'g',
            '\u01F5': 'g',
            '\u011D': 'g',
            '\u1E21': 'g',
            '\u011F': 'g',
            '\u0121': 'g',
            '\u01E7': 'g',
            '\u0123': 'g',
            '\u01E5': 'g',
            '\u0260': 'g',
            '\uA7A1': 'g',
            '\u1D79': 'g',
            '\uA77F': 'g',
            '\u24D7': 'h',
            '\uFF48': 'h',
            '\u0125': 'h',
            '\u1E23': 'h',
            '\u1E27': 'h',
            '\u021F': 'h',
            '\u1E25': 'h',
            '\u1E29': 'h',
            '\u1E2B': 'h',
            '\u1E96': 'h',
            '\u0127': 'h',
            '\u2C68': 'h',
            '\u2C76': 'h',
            '\u0265': 'h',
            '\u0195': 'hv',
            '\u24D8': 'i',
            '\uFF49': 'i',
            '\u00EC': 'i',
            '\u00ED': 'i',
            '\u00EE': 'i',
            '\u0129': 'i',
            '\u012B': 'i',
            '\u012D': 'i',
            '\u00EF': 'i',
            '\u1E2F': 'i',
            '\u1EC9': 'i',
            '\u01D0': 'i',
            '\u0209': 'i',
            '\u020B': 'i',
            '\u1ECB': 'i',
            '\u012F': 'i',
            '\u1E2D': 'i',
            '\u0268': 'i',
            '\u0131': 'i',
            '\u24D9': 'j',
            '\uFF4A': 'j',
            '\u0135': 'j',
            '\u01F0': 'j',
            '\u0249': 'j',
            '\u24DA': 'k',
            '\uFF4B': 'k',
            '\u1E31': 'k',
            '\u01E9': 'k',
            '\u1E33': 'k',
            '\u0137': 'k',
            '\u1E35': 'k',
            '\u0199': 'k',
            '\u2C6A': 'k',
            '\uA741': 'k',
            '\uA743': 'k',
            '\uA745': 'k',
            '\uA7A3': 'k',
            '\u24DB': 'l',
            '\uFF4C': 'l',
            '\u0140': 'l',
            '\u013A': 'l',
            '\u013E': 'l',
            '\u1E37': 'l',
            '\u1E39': 'l',
            '\u013C': 'l',
            '\u1E3D': 'l',
            '\u1E3B': 'l',
            '\u017F': 'l',
            '\u0142': 'l',
            '\u019A': 'l',
            '\u026B': 'l',
            '\u2C61': 'l',
            '\uA749': 'l',
            '\uA781': 'l',
            '\uA747': 'l',
            '\u01C9': 'lj',
            '\u24DC': 'm',
            '\uFF4D': 'm',
            '\u1E3F': 'm',
            '\u1E41': 'm',
            '\u1E43': 'm',
            '\u0271': 'm',
            '\u026F': 'm',
            '\u24DD': 'n',
            '\uFF4E': 'n',
            '\u01F9': 'n',
            '\u0144': 'n',
            '\u00F1': 'n',
            '\u1E45': 'n',
            '\u0148': 'n',
            '\u1E47': 'n',
            '\u0146': 'n',
            '\u1E4B': 'n',
            '\u1E49': 'n',
            '\u019E': 'n',
            '\u0272': 'n',
            '\u0149': 'n',
            '\uA791': 'n',
            '\uA7A5': 'n',
            '\u01CC': 'nj',
            '\u24DE': 'o',
            '\uFF4F': 'o',
            '\u00F2': 'o',
            '\u00F3': 'o',
            '\u00F4': 'o',
            '\u1ED3': 'o',
            '\u1ED1': 'o',
            '\u1ED7': 'o',
            '\u1ED5': 'o',
            '\u00F5': 'o',
            '\u1E4D': 'o',
            '\u022D': 'o',
            '\u1E4F': 'o',
            '\u014D': 'o',
            '\u1E51': 'o',
            '\u1E53': 'o',
            '\u014F': 'o',
            '\u022F': 'o',
            '\u0231': 'o',
            '\u00F6': 'o',
            '\u022B': 'o',
            '\u1ECF': 'o',
            '\u0151': 'o',
            '\u01D2': 'o',
            '\u020D': 'o',
            '\u020F': 'o',
            '\u01A1': 'o',
            '\u1EDD': 'o',
            '\u1EDB': 'o',
            '\u1EE1': 'o',
            '\u1EDF': 'o',
            '\u1EE3': 'o',
            '\u1ECD': 'o',
            '\u1ED9': 'o',
            '\u01EB': 'o',
            '\u01ED': 'o',
            '\u00F8': 'o',
            '\u01FF': 'o',
            '\u0254': 'o',
            '\uA74B': 'o',
            '\uA74D': 'o',
            '\u0275': 'o',
            '\u0153': 'oe',
            '\u01A3': 'oi',
            '\u0223': 'ou',
            '\uA74F': 'oo',
            '\u24DF': 'p',
            '\uFF50': 'p',
            '\u1E55': 'p',
            '\u1E57': 'p',
            '\u01A5': 'p',
            '\u1D7D': 'p',
            '\uA751': 'p',
            '\uA753': 'p',
            '\uA755': 'p',
            '\u24E0': 'q',
            '\uFF51': 'q',
            '\u024B': 'q',
            '\uA757': 'q',
            '\uA759': 'q',
            '\u24E1': 'r',
            '\uFF52': 'r',
            '\u0155': 'r',
            '\u1E59': 'r',
            '\u0159': 'r',
            '\u0211': 'r',
            '\u0213': 'r',
            '\u1E5B': 'r',
            '\u1E5D': 'r',
            '\u0157': 'r',
            '\u1E5F': 'r',
            '\u024D': 'r',
            '\u027D': 'r',
            '\uA75B': 'r',
            '\uA7A7': 'r',
            '\uA783': 'r',
            '\u24E2': 's',
            '\uFF53': 's',
            '\u00DF': 's',
            '\u015B': 's',
            '\u1E65': 's',
            '\u015D': 's',
            '\u1E61': 's',
            '\u0161': 's',
            '\u1E67': 's',
            '\u1E63': 's',
            '\u1E69': 's',
            '\u0219': 's',
            '\u015F': 's',
            '\u023F': 's',
            '\uA7A9': 's',
            '\uA785': 's',
            '\u1E9B': 's',
            '\u24E3': 't',
            '\uFF54': 't',
            '\u1E6B': 't',
            '\u1E97': 't',
            '\u0165': 't',
            '\u1E6D': 't',
            '\u021B': 't',
            '\u0163': 't',
            '\u1E71': 't',
            '\u1E6F': 't',
            '\u0167': 't',
            '\u01AD': 't',
            '\u0288': 't',
            '\u2C66': 't',
            '\uA787': 't',
            '\uA729': 'tz',
            '\u24E4': 'u',
            '\uFF55': 'u',
            '\u00F9': 'u',
            '\u00FA': 'u',
            '\u00FB': 'u',
            '\u0169': 'u',
            '\u1E79': 'u',
            '\u016B': 'u',
            '\u1E7B': 'u',
            '\u016D': 'u',
            '\u00FC': 'u',
            '\u01DC': 'u',
            '\u01D8': 'u',
            '\u01D6': 'u',
            '\u01DA': 'u',
            '\u1EE7': 'u',
            '\u016F': 'u',
            '\u0171': 'u',
            '\u01D4': 'u',
            '\u0215': 'u',
            '\u0217': 'u',
            '\u01B0': 'u',
            '\u1EEB': 'u',
            '\u1EE9': 'u',
            '\u1EEF': 'u',
            '\u1EED': 'u',
            '\u1EF1': 'u',
            '\u1EE5': 'u',
            '\u1E73': 'u',
            '\u0173': 'u',
            '\u1E77': 'u',
            '\u1E75': 'u',
            '\u0289': 'u',
            '\u24E5': 'v',
            '\uFF56': 'v',
            '\u1E7D': 'v',
            '\u1E7F': 'v',
            '\u028B': 'v',
            '\uA75F': 'v',
            '\u028C': 'v',
            '\uA761': 'vy',
            '\u24E6': 'w',
            '\uFF57': 'w',
            '\u1E81': 'w',
            '\u1E83': 'w',
            '\u0175': 'w',
            '\u1E87': 'w',
            '\u1E85': 'w',
            '\u1E98': 'w',
            '\u1E89': 'w',
            '\u2C73': 'w',
            '\u24E7': 'x',
            '\uFF58': 'x',
            '\u1E8B': 'x',
            '\u1E8D': 'x',
            '\u24E8': 'y',
            '\uFF59': 'y',
            '\u1EF3': 'y',
            '\u00FD': 'y',
            '\u0177': 'y',
            '\u1EF9': 'y',
            '\u0233': 'y',
            '\u1E8F': 'y',
            '\u00FF': 'y',
            '\u1EF7': 'y',
            '\u1E99': 'y',
            '\u1EF5': 'y',
            '\u01B4': 'y',
            '\u024F': 'y',
            '\u1EFF': 'y',
            '\u24E9': 'z',
            '\uFF5A': 'z',
            '\u017A': 'z',
            '\u1E91': 'z',
            '\u017C': 'z',
            '\u017E': 'z',
            '\u1E93': 'z',
            '\u1E95': 'z',
            '\u01B6': 'z',
            '\u0225': 'z',
            '\u0240': 'z',
            '\u2C6C': 'z',
            '\uA763': 'z',
            '\u0386': '\u0391',
            '\u0388': '\u0395',
            '\u0389': '\u0397',
            '\u038A': '\u0399',
            '\u03AA': '\u0399',
            '\u038C': '\u039F',
            '\u038E': '\u03A5',
            '\u03AB': '\u03A5',
            '\u038F': '\u03A9',
            '\u03AC': '\u03B1',
            '\u03AD': '\u03B5',
            '\u03AE': '\u03B7',
            '\u03AF': '\u03B9',
            '\u03CA': '\u03B9',
            '\u0390': '\u03B9',
            '\u03CC': '\u03BF',
            '\u03CD': '\u03C5',
            '\u03CB': '\u03C5',
            '\u03B0': '\u03C5',
            '\u03CE': '\u03C9',
            '\u03C2': '\u03C3',
            '\u2019': '\''
    };

    function stripDiacritics (text) {
        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
        function match(a) {
          return DIACRITICS[a] || a;
        }

        return text.replace(/[^\u0000-\u007E]/g, match);
    }
    function matchCustom (params, data) {
        // Always return the object if there is nothing to compare
        if ($.trim(params.term) === '') {
          return data;
        }

        // Do a recursive check for options with children
        if (data.children && data.children.length > 0) {
          // Clone the data object if there are children
          // This is required as we modify the object to remove any non-matches
          var match = $.extend(true, {}, data);

          // Check each child of the option
          for (var c = data.children.length - 1; c >= 0; c--) {
            var child = data.children[c];

            var matches = matchCustom(params, child);

            // If there wasn't a match, remove the object in the array
            if (matches == null) {
              match.children.splice(c, 1);
            }
          }

          // If any children matched, return the new object
          if (match.children.length > 0) {
            return match;
          }

          // If there were no matching children, check just the plain object
          return matchCustom(params, match);
        }

        var original = stripDiacritics(data.text).toUpperCase();
        var term = stripDiacritics(params.term).toUpperCase();

        // Check if the text contains the term
        if (original.indexOf(term) > -1) {
          return data;
        } else {
            var terms = term.split(' ');
            var score = 0;
            if (terms.length > 1) {
                for(var i = 0; i< terms.length; i++) {
                    // Check if the text contains the term
                    if (original.indexOf(terms[i]) > -1) {
                      score ++;
                    }
                }
            }
            if (score == terms.length) {
                return data;
            }
        }


        // If it doesn't contain the term, don't return anything
        return null;
    }

    $('.select2-jutjats').select2({
        matcher: matchCustom
    });

    var idioma = $('html').attr('lang');

    // Datapicker únic camp
    $('.datepicker').datetimepicker({
        locale: idioma,
        format: 'DD/MM/YYYY',
        useCurrent: false
    });


    function initInputComunicatJudicialDatepicker(selector, params)
    {
        var datepicker = $(selector);
        datepicker.datetimepicker(params).on('dp.show', function(){
            $.ajax({
                url : obtenirRutaBase()+'/calendari/comunicat-judicial',
                data: {date:datepicker.val()},
                type: 'get',
                beforeSend: function() {
                    $('.bootstrap-datetimepicker-widget .datepicker-days').prepend('<span class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></span>');
                },
                success: function(data) {
                    var nextDate = moment(data, 'YYYY-MM-DD');
                    datepicker.data("DateTimePicker").minDate(nextDate);
                    $('.bootstrap-datetimepicker-widget .datepicker-days .loading').fadeOut('400', function(){
                        $('.bootstrap-datetimepicker-widget .datepicker-days .loading').remove();
                    });
                }
            });
        });
    }

    $('.datepickerComunicatJudicial').each(function() {
        initInputComunicatJudicialDatepicker(this, {
            locale: idioma,
            minDate: Date.now(),
            format: 'DD/MM/YYYY',
            useCurrent: false
        });
    });


    function initInputFestiusDatepicker(selector, params, checkHoraTancamentBop, gestorBop)
    {
        $(selector).datetimepicker(params).on('dp.show', function(){
            var viewDate = new Date();
            if ($(this).val() != '') {
                viewDate = parseDate($(this).val(), 'dd/mm/yyyy');
            } else {
                viewDate = $(selector).data("DateTimePicker").viewDate().toDate();
            }
            $.ajax({
                url : obtenirRutaBase()+'/calendari/festius/' + viewDate.getFullYear() + '/' + (viewDate.getMonth()+1) + '?checkHoraTancamentBop=' + checkHoraTancamentBop + '&bop=' + gestorBop,
                type: 'get',
                beforeSend: function() {
                    $('.bootstrap-datetimepicker-widget .datepicker-days').prepend('<span class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></span>');
                },
                success: function(data) {
                    $(selector).data("DateTimePicker").disabledDates(data);
                    $('.bootstrap-datetimepicker-widget .datepicker-days .loading').fadeOut('400', function(){
                        $('.bootstrap-datetimepicker-widget .datepicker-days .loading').remove();
                    });
                }
            });
        }).on('dp.update', function(e){
            var viewDate = e.viewDate._d;
            $.ajax({
                url : obtenirRutaBase()+'/calendari/festius/' + viewDate.getFullYear() + '/' + (viewDate.getMonth()+1) + '?checkHoraTancamentBop=' + checkHoraTancamentBop + '&bop=' + gestorBop,
                type: 'get',
                beforeSend: function() {
                    $('.bootstrap-datetimepicker-widget .datepicker-days').prepend('<span class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></span>');
                },
                success: function(data) {
                    $(selector).data("DateTimePicker").disabledDates(data);
                    $('.bootstrap-datetimepicker-widget .datepicker-days .loading').fadeOut('400', function(){
                        $('.bootstrap-datetimepicker-widget .datepicker-days .loading').remove();
                    });
                }
            });
        }).on('dp.change', function(e){
            var viewDate = e.date._d;
            var dataDDMMYYYY = ("0" + viewDate.getDate()).slice(-2) + '/' + ("0" + (viewDate.getMonth() + 1)).slice(-2) + '/' + viewDate.getFullYear();
            $.ajax({
                url : obtenirRutaBase()+'/calendari/festius/' + viewDate.getFullYear() + '/' + (viewDate.getMonth()+1) + '?checkHoraTancamentBop=' + checkHoraTancamentBop + '&bop=' + gestorBop,
                type: 'get',
                success: function(data) {
                    $(selector).data("DateTimePicker").disabledDates(data);
                    if (data.includes(dataDDMMYYYY)) {
                        $(selector).addClass('is-invalid');
                        $(selector).val('');
                    } else {
                        $(selector).removeClass('is-invalid');
                    }
                }
            });
        });
    }
    initInputFestiusDatepicker('.datepickerFestius', {
        locale: idioma,
        minDate: Date.now(),
        format: 'DD/MM/YYYY',
        useCurrent: false,
    }, true, false);
    initInputFestiusDatepicker('.datepickerFestiusGestor', {
        locale: idioma,
        format: 'DD/MM/YYYY',
        useCurrent: false
    }, false, true);





    // Datapicker rang de dates
    $('.datepickerRangeStart').datetimepicker({
        locale: idioma,
        format: 'DD/MM/YYYY'
    });
    $('.datepickerRangeEnd').datetimepicker({
        locale: idioma,
        format: 'DD/MM/YYYY',
        useCurrent: false //Important! See issue #1075
    });
    $(".datepickerRangeStart").on("dp.change", function (e) {
        var relatedSelector = $(e.currentTarget).data('related');
        $('.datepickerRangeEnd[data-related="'+relatedSelector+'"]').data("DateTimePicker").minDate(e.date);
    });
    $(".datepickerRangeEnd").on("dp.change", function (e) {
        var relatedSelector = $(e.currentTarget).data('related');
        $('.datepickerRangeStart[data-related="'+relatedSelector+'"]').data("DateTimePicker").maxDate(e.date);
    });


    // Amagar el flash messenger automàticament
    if ($('.alert-dismissible').length > 0) {
        var count = 0;
        $('.alert-dismissible.alert-success').each (function(){
            var alert = $(this);
            var delay = count * 3000;
            alert.alert(window.setTimeout(function() {
                alert.alert('close');
            }, 6000 + delay));
            count ++;
        });
//        $('.alert-dismissible').alert(window.setTimeout(function() {
//          $('.alert-dismissible').alert('close');
//        }, 8000));
    }

    // Inicialitza validator
    if (jQuery.validator) {
        jQuery.validator.addClassRules("signCheck", {
            signCheck: true
        });

        jQuery.validator.addMethod('signCheck', function(value, element, param) {
            'use strict';

            var formData = new FormData();
            formData.append('file', element.files[0]);
            var loader = $('<div id="loader-wrapper"><div id="loader"></div><div class="loader-section section-left"></div><div class="loader-section section-right"></div></div>');
            $(element).closest('.container').append(loader);
            var result = $.ajax({
                url:  obtenirRutaBase()+'/anuncis/api/signCheck',
                //timeout: 3000, // sets timeout to 3 seconds
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                async: false
            }).responseJSON;
            loader.remove();
            return this.optional(element) || result;
        }, 'La signatura del fitxer no és valida');



        jQuery.validator.addClassRules("maxUploadSize", {
            filesize20Mb: true
        });

        $.validator.addMethod('filesize20Mb', function (value, element, param) {
            return this.optional(element) || (element.files[0].size <= 20000000)
        }, 'El fitxer ha de tenir una mida màxima de 20Mb.');

        jQuery.validator.addClassRules("validateDataConcreta", {
            validateDataConcretaMethod: true
        });


        jQuery.validator.addMethod('validateDataConcretaMethod', function(value, element) {
            return !($('input[data-dies-habils="0"]:checked').length == 1 && $('input.datepickerFestius').val() == '');
        }, 'Indiqueu una data concreta de publicació.');

        jQuery.validator.setDefaults({
          errorElement: 'span',
          errorClass: 'error help-block',
          errorPlacement: function(error, element) {
            if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
                if (element.closest('.form-group.radios.form-inline').length) {
                    element.closest('.form-group.radios.form-inline').append(error);
//            		error.insertAfter(element.closest('.form-group.radios.form-inline'));
                } else {
                    error.insertAfter(element.closest('label'));
                }
            } else if (element.parent('.input-group').length) {
              error.insertAfter(element.parent());
            } else if (element.hasClass('select2')) {
              error.insertAfter(element.closest('div').find('.select2-container '));
            } else {
              error.insertAfter(element);
            }
          },
          highlight: function(element) {
              if ($(element).hasClass('validateDataConcreta')) {
                  $(element).addClass('has-error');
              } else {
                  $(element).closest('.form-group').addClass('has-error');
              }
          },
          unhighlight: function(element) {
              if ($(element).hasClass('validateDataConcreta')) {
                  $(element).removeClass('has-error');
              } else {
                  $(element).closest('.form-group').removeClass('has-error');
              }
          }
        });

        // Missatge a la mateixa línea
        $('form').each(function() {
          $(this).validate({
              submitHandler: function(form) {
                  addLoader();
                  form.submit();
              }
          });
        });

      }


//    $('.add-another-collection-widget').click(function (e) {
//        var list = $($(this).attr('data-list'));
//        // Try to find the counter of the list
//        var counter = list.data('widget-counter') | list.children().length;
//        // If the counter does not exist, use the length of the list
//        if (!counter) { counter = list.children().length; }
//
//        // grab the prototype template
//        var newWidget = list.attr('data-prototype');
//        // replace the "__name__" used in the id and name of the prototype
//        // with a number that's unique to your emails
//        // end name attribute looks like name="contact[emails][2]"
//        newWidget = newWidget.replace(/__name__/g, counter);
//        // Increase the counter
//        counter++;
//        // And store it, the length cannot be used if deleting widgets is allowed
//        list.data(' widget-counter', counter);
//
//        // create a new list element and add it to the list
//        var newElem = $(list.attr('data-widget-tags')).html(newWidget);
//        newElem.appendTo(list);
//    });
//
    /*
     * Generar clau
     */
    $(document).on('click', '.generatePassword', function(e){
        e.preventDefault();

        var randomstring = Math.random().toString(36).substr(2, 8);
        $(".passwordFirst").val(randomstring);
        $(".passwordFirst").attr('type', 'text');
        $(".passwordSecond").val(randomstring);

        return false;
    });


    /*
     * Afegir multiples permisos en la creació d'organismes
     */

    if ($(".createUsuarisOrganismeCollection").length) {

        $('.addPermisos').click(function (e) {
            var list = $($(this).attr('data-list'));
            // Try to find the counter of the list
            var counter = list.children().length;
            // If the counter does not exist, use the length of the list
            if (!counter) { counter = list.children().length; }

            // grab the prototype template
            var newWidget = list.attr('data-prototype');
            // replace the "__name__" used in the id and name of the prototype
            // with a number that's unique to your emails
            // end name attribute looks like name="contact[emails][2]"
            newWidget = newWidget.replace(/__name__/g, counter);
            // Increase the counter
            counter++;
            // And store it, the length cannot be used if deleting widgets is allowed
            list.data(' widget-counter', counter);


            // create a new list element and add it to the list
            var newElem = $(list.attr('data-widget-tags')).html('<div class="wrapper"><button class="close delete"><span aria-hidden="true"></span></button>' + newWidget + '</div>');

            // deixem els grups de publicació amagats fins que no es selecciona un organisme
            newElem.find("select.grup option").hide();
            newElem.find("select.select2").select2();
            newElem.find("label.radio, label.checkbox").append('<span class="control-indicator"></span>');
            newElem.appendTo(list);


        });

        $(document).on('click', ".createUsuarisOrganismeCollection .wrapper button.delete", function(){
            $(this).closest('li').remove();
        });

    }

    /*
     * Amagar o mostrar el checkbox de rebre notificacions dels signataris
     */
    function updateRebreNotificacionsSignatariCheckbox() {
        var selectedSignataris = $('select.select-role option:selected').filter(function(){
            return this.textContent.startsWith('Signatari');
        });

        if (selectedSignataris.length) {
            $(".rebre-notificacions-signatari").fadeIn();
        } else {
            $(".rebre-notificacions-signatari").hide();
        }

    }
    $(document).on('change', 'select.select-role', updateRebreNotificacionsSignatariCheckbox);
    if ($('select.select-role').length) {
        updateRebreNotificacionsSignatariCheckbox();
    }

    /*
     * Afegir multiples permisos en la creació d'usuaris
     */
    if ($("#createPermisosCollection").length) {

        $('.addPermisos').click(function (e) {
            var list = $($(this).attr('data-list'));
            // Try to find the counter of the list
            var counter = list.data('widget-counter') | list.children().length;
            // If the counter does not exist, use the length of the list
            if (!counter) { counter = list.children().length; }

            // grab the prototype template
            var newWidget = list.attr('data-prototype');
            // replace the "__name__" used in the id and name of the prototype
            // with a number that's unique to your emails
            // end name attribute looks like name="contact[emails][2]"
            newWidget = newWidget.replace(/__name__/g, counter);
            // Increase the counter
            counter++;
            // And store it, the length cannot be used if deleting widgets is allowed
            list.data(' widget-counter', counter);


            // create a new list element and add it to the list
            var newElem = $(list.attr('data-widget-tags')).html('<div class="wrapper"><button class="close delete"><span aria-hidden="true"></span></button>' + newWidget + '</div>');

            // deixem els grups de publicació amagats fins que no es selecciona un organisme
            newElem.find("select.grup option").hide();
            newElem.find("select.select2").select2();
            newElem.find("label.radio, label.checkbox").append('<span class="control-indicator"></span>');

            newElem.appendTo(list);

        });

        $(document).on('click', "#createPermisosCollection .wrapper button.delete", function(){
            $(this).closest('li').remove();
        });

        $(document).on('change', "#createPermisosCollection select.organisme", function(){
            $(this).closest('li').find("select.grup option").hide();
            $(this).closest('li').find("select.grup option[data-organisme=" +$(this).val()+ "]").show();
        });
    }



    /*
     * Afegir multiples permisos en l'actualització d'usuaris
     */
    if ($("#updatePermisosCollection").length) {

        $('.addPermisos').click(function (e) {
            var list = $($(this).attr('data-list'));
            // Try to find the counter of the list
            var counter = list.data('widget-counter') | list.children().length;
            // If the counter does not exist, use the length of the list
            if (!counter) { counter = list.children().length; }

            // grab the prototype template
            var newWidget = list.attr('data-prototype');
            // replace the "__name__" used in the id and name of the prototype
            // with a number that's unique to your emails
            // end name attribute looks like name="contact[emails][2]"
            newWidget = newWidget.replace(/__name__/g, counter);
            // Increase the counter
            counter++;
            // And store it, the length cannot be used if deleting widgets is allowed
            list.data(' widget-counter', counter);


            // create a new list element and add it to the list
            var newElem = $(list.attr('data-widget-tags')).html('<div class="wrapper"><button class="close delete"><span aria-hidden="true"></span></button>' + newWidget + '</div>');

            // deixem els grups de publicació amagats fins que no es selecciona un organisme
            newElem.find("select.grup option").hide();
            newElem.find("select.select2").select2();
            newElem.find(".only-for-existing-items").hide();
            newElem.find("select:disabled").removeProp('disabled');
            newElem.find("label.radio, label.checkbox").append('<span class="control-indicator"></span>');
            newElem.appendTo(list);
            newElem.find('select.organisme,select.grup').each(function () {
                $(this).rules('add', {
                    required: true
                });
            });
        });

        $(document).on('click', "#updatePermisosCollection .wrapper button.delete", function(){
            $(this).closest('li').find('select.organisme,select.grup').each(function () {
                $(this).rules('remove');
            });
            $(this).closest('li').remove();
        });

        $(document).on('change', "#updatePermisosCollection select.organisme", function(){
            $(this).closest('li').find("select.grup option").hide();
            $(this).closest('li').find("select.grup option[data-organisme=" +$(this).val()+ "]").show();
        });
    }



    /*
     * Afegir multiples permisos en la creació d'usuaris
     */
    function initConvocatroiesCollection() {
        $('.addPermisos').click(function (e) {
            var list = $($(this).attr('data-list'));

            // Try to find the counter of the list
            var counter = list.data('widget-counter') | list.children().length;
            // If the counter does not exist, use the length of the list
            if (!counter) { counter = list.children().length; }
            // grab the prototype template
            var newWidget = list.attr('data-prototype');
            // replace the "__name__" used in the id and name of the prototype
            // with a number that's unique to your emails
            // end name attribute looks like name="contact[emails][2]"
            newWidget = newWidget.replace(/__name__/g, counter);
            // Increase the counter
            counter++;
            // And store it, the length cannot be used if deleting widgets is allowed
            list.data(' widget-counter', counter);

            // create a new list element and add it to the list
            var newElem = $(list.attr('data-widget-tags')).html('<div class="wrapper"><button class="close delete"><span aria-hidden="true"></span></button>' + newWidget + '</div>');

            newElem.appendTo(list);
        });

        $(document).on('click', "#convocatoriesCollection .wrapper button.delete", function(){
            $(this).closest('li').remove();
        });
    }
    if ($("#convocatoriesCollection").length) {
        initConvocatroiesCollection();
    }



    $('[data-toggle="tooltip"]').tooltip();

    vex.defaultOptions.className = "vex-theme-plain";

    $(document).on('click', "a.confirmAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        vex.dialog.confirm({
            message: message,
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(value) {
                if (value) {
                    window.location = url
                }
            }
        });
    });


    $(document).on('click', "a.confirmCorreccioAnunciAction", function(event) {
        event.preventDefault();

        var url = $(this).attr('href');
        var message = $(this).data('message');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var anunciId = $(this).data('anunci-id');
        vex.dialog.confirm({
            message: message,
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(value) {
                if (value) {
                    addLoader();
                    $.ajax({
                        url: url,
                        type: 'get',
                        success: function(data) {
                            $.ajax({
                                url: obtenirRutaBase()+'/bop/anuncis/ajax-related/' + anunciId,
                                type: 'get',
                                success: function(data) {
                                    $('#llista-correccions').html(data);
                                    removeLoader();
                                }
                            });
                        }
                    });
                }
            }
        });
    });

    $(document).on('click', "a.confirmWithMessageAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var ajaxCallbackUrl = $(this).data('ajax-callback-url');
        var anunciId = $(this).data('anunci');
        vex.dialog.prompt({
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<input name="vex" type="text" required="required" value="" />',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "string" && data !== undefined){
                    window.location = url+'?message=' + data;
                }
            }
        });
    });

    $(document).on('click', "a.confirmWithMessageCheckboxAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var checkboxLabel = $(this).data('checkbox-label');
        var checkboxValue = $(this).data('checkbox-value');
        var checkboxName = $(this).data('checkbox-name');
        vex.dialog.prompt({
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<input name="vex[text]" type="text" required="required" value="" />',
                        '<div class="checkbox"><label class="control checkbox"><input type="checkbox" name="vex[checkbox]" value="'+checkboxValue+'">'+checkboxLabel+'<span class="control-indicator"></span></label>',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "object" && data.text !== undefined){
                    var location = url+'?message=' + data.text;
                    if (data.checkbox !== undefined) {
                        location = location + '&' + checkboxName + '=' + data.checkbox;
                    }
                    window.location = location;
                }
            }
        });
    });


    $(document).on('click', "a.confirmResoldreIncidenciaAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var title = $(this).data('title');
        var radioLabel = $(this).data('radio-label');
        var radioPublicar = $(this).data('radio-publicar');
        var radioAnular = $(this).data('radio-anular');

        var motiu = $(this).data('motiu');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var confirm = vex.dialog.prompt({
            unsafeMessage: '<h3>' + title + '</h3><p>' + message + '</p>',
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<h3>' + radioLabel + '</h3>',
                        '<div class="checkbox">',
                            '<label class="control radio"><input type="radio" required name="vex[radio]" value="1" class="publica">'+radioPublicar+'<span class="control-indicator"></span></label>',
                            '<label class="control radio"><input type="radio" required name="vex[radio]" value="2" class="anula">'+radioAnular+'<span class="control-indicator"></span></label>',
                        '</div>',
                        '<div class="message" style="display:none">',
                            '<label>' + motiu + '</label>',
                            '<input name="vex[text]" type="text" value="" />',
                        '</div>',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "object" && data.radio !== undefined){
                    var location = url + '?action=' + data.radio;
                    if (data.text !== undefined) {
                        location = location + '&message=' + data.text;
                    }
                    window.location = location;
                }
            }
        });
        $(confirm.form).find('input.anula,input.publica').on('change', function(){
            var checked = $(confirm.form).find('input.anula').is(':checked');
            $(confirm.form).find('.message').toggle(checked);
            $(confirm.form).find('.message input').attr("required", checked);
        });

    });



    $(document).on('change', 'select[name="vex[select]"]', function(){
        if ($(this).find(':selected').data('copy-content')) {
            $('textarea[name="vex[text]"]').text($(this).val());
        } else {
            $('textarea[name="vex[text]"]').text('');
        }
    });

    var vexActive = false;
    $("button.confirmSubmit").click(function(event) {
        if (vexActive) {
            return true;
        }
        event.preventDefault();
        var form = $(this).closest('form');
        var message = $(this).data('message');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var button = $(this);

        vex.dialog.confirm({
            message: message,
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(value) {
                if (value) {
                    vexActive = true;
                    button.trigger('click');
                }
            }
        });
    });



    /*
     * Formulari de filtre
     */
    if ($('.filterVisibilitat').length) {
        $('.filterVisibilitat input:radio').change(function(e) {
            $(this).closest('form').submit();
        });
    }

    if ($('.filterForm').length) {
        $("#showFilter").click(function(e){
            e.preventDefault();
            $(this).toggleClass('btn-active');
            $('.filterForm').toggleClass('hidden');
            return false;
        });
    }

    /*
     * Text area max length
     */

    $("textarea[maxlength]").each(function(){
        $(this).after('<span id="' +  $(this).attr('id') + '_maxlengthinfo"></span>');
        $(this).on("keyup change paste", function () {

            var content = $(this).val();
            var maxLength = $(this).attr('maxlength');
            var messageContainer = $("#" +  $(this).attr('id') + "_maxlengthinfo");

            var CountMessage = "<small>" + content.length.toString() + "/" + maxLength + "</small>";

            if (content.length > maxLength) {
                messageContainer.html("<span class=\"counter-alert alert-danger\">" + CountMessage + "</span> ");
            } else if (content.length == 0) {
                messageContainer.html("");
            } else {
                messageContainer.html("<span class=\"counter-alert\">" + CountMessage + "</span> ");
            }
        });
    });


    /*
     * Selecciona organismes judicials
     */
    if ($('#select-tribunals').length) {
        // autosubmit al seleccionar un organisme
        $('#select-tribunals .form-select select').change(function(){
            $(this).closest('form').submit();
        });
        // mostrar select amb tots els organismes
        $('#select-tribunals #show-organismes-judicials').click(function(e){
            e.preventDefault();
            $(this.hash).toggleClass('hidden');
            return false;
        });
    }


    /*
     * Form anunci
     */
    if ($('#form-anunci').length) {

        var inputFile = null;
        var inputFileLabel = null;
        $('#update_anunci_request_adjunt, #create_anunci_request_adjunt').change(function (event) {
            // IE has its own API for creating and downloading files, which is called msSaveOrOpenBlob.
            if (window.navigator.msSaveOrOpenBlob) {
                var blobObject = new Blob([event.target.files[0]]);
                var fileName = event.target.files[0].name;
                $('#anunci_attatch_preview').html('<p class="anunci-attatch">'
                        + '<a class="btn btn-link-icon btn-sm external" href="#" id="ieDownloadPDF"><i class="material-icons" aria-hidden="true">&#xe24d;</i> ' + event.target.files[0].name + '</a>'
                        + '<a href="#" class="btn" id="anunci_attatch_preview-delete" ><i data-toggle="tooltip" data-placement="top" class="material-icons" aria-hidden="true">&#xe14c;</i>' + $(this).data('delete-label') + '</a>'
                        + '</p>');
                $(document).on('click', '#ieDownloadPDF', function(e){
                    e.preventDefault();
                    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                    return false;
                });
            } else {
                var file = URL.createObjectURL(event.target.files[0]);
                inputFile = $(this);
                inputFileLabel = $(this).closest('.form-group').find('label span');

                $('#anunci_attatch_preview').html('<p class="anunci-attatch">'
                    + '<a class="btn btn-link-icon btn-sm external" href="' + file + '" target="_blank"><i class="material-icons" aria-hidden="true">&#xe24d;</i> ' + event.target.files[0].name + '</a>'
                    + '<a href="#" class="btn" id="anunci_attatch_preview-delete" ><i data-toggle="tooltip" data-placement="top" class="material-icons" aria-hidden="true">&#xe14c;</i>' + $(this).data('delete-label') + '</a>'
                    + '</p>');
            }
        });
        $('#form-anunci').on('click', '#anunci_attatch_preview-delete', function (e){
            e.preventDefault();

            $('#anunci_attatch_preview').fadeOut(400, function(){
                inputFile.replaceWith(inputFile.val('').clone(true));
                inputFileLabel.text(inputFile.data('default-label'));
                $('#anunci_attatch_preview').html('');
                $('#anunci_attatch_preview').show();
            });
            return false;
        });

//
//	    $('label.quiPaga input').change(function(e){
//	        $("#altre-pagador").toggleClass('hidden');
//	    });
//
//	    function initPagadorModal()
//	    {
//	    	$('#pagadorModal form').validate({
//	    		submitHandler: function(form) {
//	    			$.post( form.action, $(form).serialize(), function(data) {
//	                      $('#pagadorModal .modal-content').html(data);
//	                      initPagadorModal();
//	    			}, 'html');
//	    		}
//	    	});
//	    }
//
//	    $("#pagadorModal").on('loaded.bs.modal', function (e){
//	        initPagadorModal();
//	    });
//
//
//	    function updateSelectPagadorOptions(selectContainerHash, selectedOptionId)
//	    {
//	    	var data = {};
//	    	var url = $(selectContainerHash).data('url-pagador-select-options');
//	    	var select = $(selectContainerHash).find('select');
//	    	var newSelection = selectedOptionId;
//	        $.ajax({
//	            url : url,
//	            type: 'post',
//	            success: function(data) {
//	            	select.html(data);
//	            	select.trigger('change');
//	            	updateSelectUserSelection(select, newSelection);
//
//	            }
//	        });
//	    }
//
//	    function updateSelectPagadorSelection(select, selectedOptionId)
//	    {
//	    	select.find('option:selected').removeAttr('selected').removeProp('selected');
//	        select.find('option[value="' + selectedOptionId + '"]').attr('selected', 'selected').prop('selected', true);
//	        select.trigger('change');
//	    }
//
//	    $(document).on('click', '.seleccionaPagadorExistent', function(e){
//	        e.preventDefault();
//
//	        updateSelectPagadorSelection($('#altre-pagador select'), $(this).data('pagador-id'));
//
//	        $('#pagadorModal').modal('toggle');
//
//	        return false;
//	    });
//
//	    $(document).on('click', '.seleccionaNouPagador', function(e){
//	        e.preventDefault();
//
//	        updateSelectPagadorOptions('#altre-pagador', $(this).data('pagador-id'));
//
//	        $('#pagadorModal').modal('toggle');
//
//	        return false;
//	    });
//
//
//	    $('#altre-pagador select').change(function(e){
//	        var data = {};
//	        data['idPagador'] = $(this).val();
//	        var pagadorInfoContainer = $('#altre-pagador .pagador-data');
//	        $.ajax({
//	            url : $('#altre-pagador').data('url-pagador-details'),
//	            type: 'post',
//	            data : data,
//	            success: function(html) {
//	            	pagadorInfoContainer.html(html);
//	            }
//	        });
//
//	    });


        $('body').on('hidden.bs.modal', '.modal', function () {
              $(this).removeData('bs.modal');
        });

        // radios notificació judicial
        $('.tipus-comunicat-judicial input.datepickerComunicatJudicial').click(function(e){
            $(this).closest('div').find('input:radio').prop('checked', 'checked');
        });

        $('.tipus-comunicat-judicial input:radio').click(function(e){
            $('.tipus-comunicat-judicial').find('input.datepickerComunicatJudicial').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled').removeAttr('required').val('');
            $(this).closest('div').find('input.datepickerComunicatJudicial').removeProp('disabled').removeAttr('disabled').removeClass('disabled').attr('required', 'required');
        });

        if ($('.tipus-comunicat-judicial input:checked').length) {
            $('.tipus-comunicat-judicial').find('input.datepickerComunicatJudicial').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled').removeAttr('required');
            $('.tipus-comunicat-judicial input:checked').closest('div').find('input.datepickerComunicatJudicial').removeProp('disabled').removeAttr('disabled').removeClass('disabled').attr('required', 'required');
        }

        // radios tarifa publicació
        $('.tarifa-publicacio input.datepicker').click(function(e){
            $(this).closest('div').find('input:radio').prop('checked', 'checked');
        });
        $('.tarifa-publicacio input:radio').click(function(e){
            $('.tarifa-publicacio').find('input.datepicker').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled');
            $(this).closest('div').find('input.datepicker').removeProp('disabled').removeAttr('disabled').removeClass('disabled');
        });

        if ($('.tarifa-publicacio input:checked').length) {
            $('.tarifa-publicacio').find('input.datepicker').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled');
            $('.tarifa-publicacio input:checked').closest('div').find('input.datepicker').removeProp('disabled').removeAttr('disabled').removeClass('disabled');
        }

        if ($('.tarifa-publicacio input.datepickerFestius').length) {
            function checkShowTarifaCostMessage()
            {
                if ($('.tarifa-publicacio input.datepickerFestius').val() != '') {
                    $.ajax({
                        url : obtenirRutaBase()+'/anuncis/data-estimada-publicacio-concreta/' + moment($('.tarifa-publicacio input.datepickerFestius').val(), 'DD/MM/YYYY').format('YYYY-MM-DD') ,
                        type: 'get',
                        success: function(html) {
                            $("#data-estimada-concreta").html(html);
                        }
                    });
                }

            }

            $('.tarifa-publicacio input:radio').on('change', function() {
                checkShowTarifaCostMessage();
            });

            $('.tarifa-publicacio input.datepickerFestius').on('dp.change', function() {
                $('.tarifa-publicacio input[data-dies-habils=0]').prop('checked', 'checked');
                checkShowTarifaCostMessage();
            });

            checkShowTarifaCostMessage();
        }


    }


    /*
     * Form usuari
     */

    // Actualització del select.grup de Grup de Publicació en funció del select.organisme
    $(document).on('change', 'select.organisme', function() {
        var data = {};
        data['idOrganisme'] = $(this).val();
        var selectGrup = $(this).closest('.wrapper').find('select.grup');
        $.ajax({
            url : obtenirRutaBase()+$(this).data('url-grup-publicacions'),
            type: 'post',
            data : data,
            success: function(html) {
                selectGrup.html(html);
            }
        });
    });

    if ($('#specialUsers').length) {
        $(document).on('change', '#specialUsers input', function(e){
            if ( $('#specialUsers input:checked').length) {
                $('#permisosUsuari').fadeOut();
                $('#passwordUsuari').fadeOut();
            } else {
                $('#permisosUsuari').fadeIn();
                $('#passwordUsuari').fadeIn();
            }
        });

        function disablePermisosBop()
        {
            if ($('#update_usuari_request_esProcurador').is(':checked')) {
                $('#update_usuari_request_esEditorBop').addClass('disabled');
                $('label[for="update_usuari_request_esEditorBop"]').addClass('disabled');
                $('#update_usuari_request_esEditorBop').prop('disabled', 'disabled');
                $('#update_usuari_request_esEditorBop').prop('checked', false);

                $('#update_usuari_request_esAdministrador').addClass('disabled');
                $('label[for="update_usuari_request_esAdministrador"]').addClass('disabled');
                $('#update_usuari_request_esAdministrador').prop('disabled', 'disabled');
                $('#update_usuari_request_esAdministrador').prop('checked', false);
            } else {
                $('#update_usuari_request_esEditorBop').removeClass('disabled');
                $('label[for="update_usuari_request_esEditorBop"]').removeClass('disabled');
                $('#update_usuari_request_esEditorBop').prop('disabled', '');

                $('#update_usuari_request_esAdministrador').removeClass('disabled');
                $('label[for="update_usuari_request_esAdministrador"]').removeClass('disabled');
                $('#update_usuari_request_esAdministrador').prop('disabled', '');
            }

        }

        function disablePermisosProcurador()
        {
            if ($('#update_usuari_request_esEditorBop').is(':checked') || $('#update_usuari_request_esAdministrador').is(':checked') ) {
                $('#update_usuari_request_esProcurador').addClass('disabled');
                $('label[for="update_usuari_request_esProcurador"]').addClass('disabled');
                $('#update_usuari_request_esProcurador').prop('disabled', 'disabled');
                $('#update_usuari_request_esProcurador').prop('checked', false);

            } else {
                $('#update_usuari_request_esProcurador').removeClass('disabled');
                $('label[for="update_usuari_request_esProcurador"]').removeClass('disabled');
                $('#update_usuari_request_esProcurador').prop('disabled', '');

            }
        }

        $(document).on('change', '#update_usuari_request_esProcurador', disablePermisosBop);
        $(document).on('change', '#update_usuari_request_esEditorBop, #update_usuari_request_esAdministrador', disablePermisosProcurador);

        disablePermisosBop();
        disablePermisosProcurador();
    }

    /*
     * Form organisme
     */
    if ($('#form-organisme').length) {
        var usuariTarget;
        function initUsuariOrganismeModal()
        {

            $('#usuariModal form').validate({
                submitHandler: function(form) {
                    $.post( form.action, $(form).serialize(), function(data) {
                        $('#usuariModal .modal-content').html(data);
                          $("#usuariModal .modal-content legend")
                              .wrapInner("<div class='container'></div>")
                              .css("display", "block");

                          initUsuariOrganismeModal();
                    }, 'html');
                }
            });

        }
        $("#usuariModal").on('show.bs.modal', function (e){
            usuariTarget = $(e.relatedTarget).data('usuari');
        });

        $("#usuariModal").on('loaded.bs.modal', function (e){
            initUsuariOrganismeModal();
        });


        function updateSelectUserOptions(selectContainerHash, selectedOptionId)
        {
            var data = {};
            var url = $(selectContainerHash).data('url-user-select-options');
            var select = $(selectContainerHash).find('select');
            var newSelection = selectedOptionId;
            $.ajax({
                url : url,
                type: 'post',
                success: function(data) {
                    select.html(data);
                    select.trigger('change');
                    updateSelectUserSelection(select, newSelection);

                }
            });
        }

        function updateSelectUserSelection(select, selectedOptionId)
        {
            select.find('option:selected').removeAttr('selected').removeProp('selected');
            select.find('option[value="' + selectedOptionId + '"]').attr('selected', 'selected').prop('selected', true);
            select.trigger('change');
        }

        $(document).on('click', '.seleccionaUsuariExistent', function(e){
            e.preventDefault();

            updateSelectUserSelection($('#' + usuariTarget).find('select'), $(this).data('usuari-id'));

            $('#usuariModal').modal('toggle');

            return false;
        });

        $(document).on('click', '.seleccionaNouUsuari', function(e){
            e.preventDefault();

            updateSelectUserOptions('#' + usuariTarget, $(this).data('usuari-id'));

            $('#usuariModal').modal('toggle');

            return false;
        });

        $(document).on('change', '.usuari-select select', function(e) {
            var data = {};
            data['idUsuari'] = $(this).val();
            var userInfoContainer = $(this).closest('.usuari-select').find('.user-data');
            $.ajax({
                url : $(this).closest('.usuari-select').data('url-user-details'),
                type: 'post',
                data : data,
                success: function(html) {
                    userInfoContainer.html(html);
                }
            });

        });

        $('body').on('hidden.bs.modal', '.modal', function () {
            $(this).removeData('bs.modal');
        });
    }

    /*
     * Form contacte
     */

    if ($("#form-contacta").length) {

        // radios mitjà contacte
        $('#mitja-contacte input[data-type="email"]').click(function(e){
            $('#mitja-contacte :radio[data-type="email"]').prop('checked', 'checked');
            $('#mitja-contacte input[data-type="telefon"]:not(:radio)').val('').valid();
            $('#mitja-contacte input[data-type="telefon"]:not(:radio)').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled');
        });
        $('#mitja-contacte input[data-type="telefon"]').click(function(e){
            $('#mitja-contacte :radio[data-type="telefon"]').prop('checked', 'checked');
            $('#mitja-contacte input[data-type="email"]:not(:radio)').val('').valid();
            $('#mitja-contacte input[data-type="email"]:not(:radio)').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled');
        });
        $('#mitja-contacte input:radio').click(function(e){
            $('#mitja-contacte').find('input:not(:radio)').prop('disabled', 'disabled').attr('disabled', 'disabled').addClass('disabled');
            $('#mitja-contacte').find('input[data-type="' + $(this).data('type') + '"]').removeProp('disabled').removeAttr('disabled').removeClass('disabled');
        });
    }

    /*
     * Form tauler cerca
     */
    $('.opener .opener-trigger').on('click', function(e){
        $(this).parent('.opener').toggleClass('open');
    })

    // Actualització del select.grup de Grup de Publicació en funció del select.organisme
    $(document).on('change', 'select.organismeCerca', function() {
        var data = {};
        data['idOrganisme'] = $(this).val();
        var selectGrup = $(this).closest('fieldset').find('select.grup');
        $.ajax({
            url : obtenirRutaBase()+$(this).data('url-grup-publicacions'),
            type: 'post',
            data : data,
            success: function(html) {
                if (html != '') {
                    html = '<option value="">Selecciona un grup</option>' + html;
                }
                selectGrup.html(html);
            }
        });
    });

    /*
     * Control cookies dels avisos d'usuari
     */
    if ($('body.logged').length && $('.dropdown-notificacions .dropdown-menu-list li').length) {
        var adviseId = $('.dropdown-notificacions .dropdown-menu-list li:first a').data('advise-id');
        if ($.cookie('advise-readed-' + adviseId) != 'yes') {
            $('.dropdown-notificacions .dropdown-menu-list li:first a').trigger('click');
        }

        $('.modal-avis').on('hidden.bs.modal', function(e){
            $.cookie('advise-readed-' + adviseId, 'yes', {expires: 360, path: '/'});
        });
    }

    /*
     * Form validació anunci
     */
    // Actualització del select.grup de Grup de Publicació en funció del select.organisme
    $(document).on('change', 'select.organismeValidate', function() {
        var data = {};
        data['idOrganisme'] = $(this).val();
        var selectGrup = $(this).closest('dl').find('select.grup');
        $.ajax({
            url : obtenirRutaBase()+$(this).data('url-grup-publicacions'),
            type: 'post',
            data : data,
            success: function(html) {
                if (html != '') {
                    html = /*'<option>Selecciona un grup</option>' +*/ html;
                }
                selectGrup.html(html);
            }
        });
    });

    $('select.organismeValidate').select2({
        width: '100%'
    });

    // Actualització del select.grup de Grup de Publicació en funció del select.organisme
    $(document).on('click', 'a.anunciantChange', function(event) {
        event.preventDefault();
        var dl = $(this).closest('dl');
        dl.find('.noediting').hide();
        dl.find('.editing').show();
    });


    function disableValidateAnunciCheck()
    {
        if (!$('#validate_anunci_request_validat').data('readonly')) {
            if ($('#validate_anunci_request_revisat').is(':checked')) {
                $('#validate_anunci_request_validat').removeClass('disabled');
                $('label[for="validate_anunci_request_validat"]').removeClass('disabled');
                $('#validate_anunci_request_validat').prop('disabled', false);
            } else {
                $('#validate_anunci_request_validat').addClass('disabled');
                $('label[for="validate_anunci_request_validat"]').addClass('disabled');
                $('#validate_anunci_request_validat').removeAttr('disabled');
                $('#validate_anunci_request_validat').prop('disabled', 'disabled');
                $('#validate_anunci_request_validat').prop('checked', false);
            }
        }
    }
    $(document).on('change', '#validate_anunci_request_revisat', disableValidateAnunciCheck);
    disableValidateAnunciCheck();


    function addLoader()
    {
        $('body').append('<div id="loader-wrapper"><div id="loader"></div><div class="loader-section section-left"></div><div class="loader-section section-right"></div></div>');
    }
    function removeLoader()
    {
        $('#loader-wrapper').remove();
    }
    $(document).on("click", "button[data-hide-validate-form]", function(event) {
        event.preventDefault();

        $('tr.form-anunci-container#' + $(this).data('hide-validate-form') + ' td').html('');
        $('tr.form-anunci-container#' + $(this).data('hide-validate-form')).addClass('hidden');
    });

    function initBOPValidateForm(anunciId, data)
    {
        $('tr.form-anunci-container').addClass('hidden');
        $('tr.form-anunci-container#anunci-' + anunciId + ' td').html(data);
        $('tr.form-anunci-container#anunci-' + anunciId + ' td label.radio, tr.form-anunci-container#anunci-' + anunciId + ' td label.checkbox').append('<span class="control-indicator"></span>');

        $('.select2').select2({
            width: '100%'
        });

        $('select.organismeValidate').select2({
            width: '100%'
        });

        initInputFestiusDatepicker('.datepickerFestiusGestor', {
            locale: idioma,
            format: 'DD/MM/YYYY',
            useCurrent: false
        }, false, true);

        initInputComunicatJudicialDatepicker('tr.form-anunci-container#anunci-' + anunciId + ' .datepickerComunicatJudicial',{
            locale: idioma,
            format: 'DD/MM/YYYY',
            useCurrent: false
        });
        $('a:external, a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external');
        disableValidateAnunciCheck()

        $('tr.form-anunci-container#anunci-' + anunciId).removeClass('hidden');
    }

    $("a.load-validate-form").click(function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var anunciId = $(this).data('anunci');
        addLoader();
        $.ajax({
          url : url,
          type: 'get',
          success: function(data) {
              initBOPValidateForm(anunciId, data);
              removeLoader();
          }
        });
        return false;
    });

    $(document).on('change', '#validate_anunci_request_pdfMaquetat, #validate_anunci_request_pdfPublicat', function (event) {
        // IE has its own API for creating and downloading files, which is called msSaveOrOpenBlob.
        if (window.navigator.msSaveOrOpenBlob) {
            var blobObject = new Blob([event.target.files[0]]);
            var fileName = event.target.files[0].name;
            $(this).closest('.form-group').find('.anunci_attatch_preview').html('<p class="anunci-attatch">'
                    + '<a class="btn btn-link-icon btn-sm external" href="#" id="ieDownloadPDF' + $(this).attr("id") + '"><i class="material-icons" aria-hidden="true">&#xe24d;</i> ' + event.target.files[0].name + '</a>'
                    + '<a href="#" class="btn anunci_attatch_preview-delete" ><i data-toggle="tooltip" data-placement="top" class="material-icons" aria-hidden="true">&#xe14c;</i>' + $(this).data('delete-label') + '</a>'
                    + '</p>');
            $(document).on('click', '#ieDownloadPDF' + $(this).attr("id"), function(e){
                e.preventDefault();
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                return false;
            });
        } else {
            var file = URL.createObjectURL(event.target.files[0]);
            $(this).closest('.form-group').find('.anunci_attatch_preview').html('<p class="anunci-attatch">'
                + '<a class="btn btn-link-icon btn-sm external" href="' + file + '" target="_blank"><i class="material-icons" aria-hidden="true">&#xe24d;</i> ' + event.target.files[0].name + '</a>'
                + '<a href="#" class="btn anunci_attatch_preview-delete" ><i data-toggle="tooltip" data-placement="top" class="material-icons" aria-hidden="true">&#xe14c;</i>' + $(this).data('delete-label') + '</a>'
                + '</p>');
        }
    });
    $(document).on('click', '#form-anunci .anunci_attatch_preview-delete', function (e){
        e.preventDefault();
        var inputFile = $(this).closest('.form-group').find('input.inputfile');
        var inputFileLabel = $(this).closest('.form-group').find('label span');
        var docPreview = $(this).closest('.form-group').find('.anunci_attatch_preview');
        docPreview.fadeOut(400, function(){
            inputFileLabel.text(inputFile.data('default-label'));
            inputFile.replaceWith(inputFile.val('').clone(true));
            docPreview.html('');
            docPreview.show();
        });
        return false;
    });

    $(document).on('click', "a[href='#editFilesContainer']", function(e){
        e.preventDefault();
        $(this).fadeOut();
        $(this).closest('form').find('.editFilesContainer').toggleClass('hidden');
        return false;
    });


    $(document).on('submit', "form.submit-validate-form", function(event) {
        event.preventDefault();
        var formData = new FormData(this);
        var form = $(this);
        var url = form.attr('action');
        var anunciId = form.data('anunci');
        addLoader();
        $.ajax({
            url: url,
            type: 'post',
            data: formData,
//            data: form.serialize(),
            cache: false,
            contentType: false,
            processData: false,
            success: function(data) {
                initBOPValidateForm(anunciId, data);
                removeLoader();
            }
          });
        return false;
    });

    $(document).on('click', "a.confirmValidationWithMessageAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var ajaxCallbackUrl = $(this).data('ajax-callback-url');
        var anunciId = $(this).data('anunci');
        vex.dialog.prompt({
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<input name="vex" type="text" required="required" value="" />',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "string" && data !== undefined){
                    var location = url+'?message=' + data;
                    if (!ajaxCallbackUrl) {
                        window.location = location;
                    } else {
                        location += '&redirect=' + ajaxCallbackUrl;
                        addLoader();
                        $.ajax({
                            url: location,
                            type: 'get',
                            success: function(data) {
                                initBOPValidateForm(anunciId, data);
                                removeLoader();
                            }
                        });
                    }
                }
            }
        });
    });

    $(document).on('click', "a.confirmValidationWithMessageCheckboxAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var checkboxLabel = $(this).data('checkbox-label');
        var checkboxValue = $(this).data('checkbox-value');
        var checkboxName = $(this).data('checkbox-name');
        var ajaxCallbackUrl = $(this).data('ajax-callback-url');
        var anunciId = $(this).data('anunci');
        vex.dialog.prompt({
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<input name="vex[text]" type="text" required="required" value="" />',
                        '<div class="checkbox"><label class="control checkbox"><input type="checkbox" name="vex[checkbox]" value="'+checkboxValue+'">'+checkboxLabel+'<span class="control-indicator"></span></label>',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "object" && data.text !== undefined){
                    var location = url+'?message=' + data.text;
                    if (data.checkbox !== undefined) {
                        location = location + '&' + checkboxName + '=' + data.checkbox;
                    }

                    if (!ajaxCallbackUrl) {
                        window.location = location;
                    } else {
                        location += '&redirect=' + ajaxCallbackUrl;
                        addLoader();
                        $.ajax({
                            url: location,
                            type: 'get',
                            success: function(data) {
                                initBOPValidateForm(anunciId, data);
                                removeLoader();
                            }
                        });
                    }
                }
            }
        });
    });

    $(document).on('click', "a.confirmValidationWithMessageOptionsAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var ajaxCallbackUrl = $(this).data('ajax-callback-url');
        var anunciId = $(this).data('anunci');

        var options = $(this).data('options');

        var optionsHtml = '';
        for(i = 0; i < options.length; i++) {
            optionsHtml += '<option value="' + options[i].motiu + '" data-copy-content="' + options[i].utilitzarComATextBase+ '">' + options[i].motiu + '</option>'
        }
        vex.dialog.prompt({
            contentClassName: 'vex-content-large',
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<div class="select"><select name="vex[select]" name="vex-options"><option></option>' + optionsHtml + '</select></div>',
                        '<textarea name="vex[text]" required="required"></textarea>',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "object" && data.text !== undefined){
                    var location = url+'?message=' + data.text;

                    if (!ajaxCallbackUrl) {
                        window.location = location;
                    } else {
                        location += '&redirect=' + ajaxCallbackUrl;
                        addLoader();
                        $.ajax({
                            url: location,
                            type: 'get',
                            success: function(data) {
                                initBOPValidateForm(anunciId, data);
                                removeLoader();
                            }
                        });
                    }
                }
            }
        });
    });

    $(document).on('click', "a.confirmValidationWithMessageOptionsAndCheckboxAction", function(event) {
        event.preventDefault();
        var url = $(this).attr('href');
        var message = $(this).data('message');
        var placeholder = $(this).data('placeholder');
        var labelOk = $(this).data('label-ok');
        var labelCancel = $(this).data('label-cancel');
        var checkboxLabel = $(this).data('checkbox-label');
        var checkboxValue = $(this).data('checkbox-value');
        var checkboxChecked = $(this).data('checkbox-checked');
console.log(checkboxChecked);
        var checkboxName = $(this).data('checkbox-name');
        var ajaxCallbackUrl = $(this).data('ajax-callback-url');
        var anunciId = $(this).data('anunci');

        var options = $(this).data('options');

        var optionsHtml = '';
        for(i = 0; i < options.length; i++) {
            optionsHtml += '<option value="' + options[i].motiu.replace(/"/g, '&quot;')+ '" data-copy-content="' + options[i].utilitzarComATextBase+ '">' + options[i].motiu + '</option>'
        }
        vex.dialog.prompt({
            contentClassName: 'vex-content-large',
            message: message,
            placeholder: placeholder,
            input: [
                '<div class="vex-custom-field-wrapper">',
                    '<div class="vex-custom-input-wrapper">',
                        '<div class="select"><select name="vex[select]" name="vex-options"><option></option>' + optionsHtml + '</select></div>',
                        '<textarea name="vex[text]" required="required"></textarea>',
                        '<div class="checkbox"><label class="control checkbox"><input type="checkbox" name="vex[checkbox]" value="'+checkboxValue+'" '+((checkboxChecked)?'checked':'')+'>'+checkboxLabel+'<span class="control-indicator"></span></label>',
                    '</div>',
                '</div>',
            ].join(''),
            buttons: [
                $.extend({}, vex.dialog.buttons.YES, {
                    text: labelOk
                }), $.extend({}, vex.dialog.buttons.NO, {
                    text: labelCancel
                })
            ],
            callback: function(data) {
                if (typeof data === "object" && data.text !== undefined){
                    var location = url+'?message=' + data.text;
                    if (data.checkbox !== undefined) {
                        location = location + '&' + checkboxName + '=' + data.checkbox;
                    }

                    if (!ajaxCallbackUrl) {
                        window.location = location;
                    } else {
                        location += '&redirect=' + ajaxCallbackUrl;
                        addLoader();
                        $.ajax({
                            url: location,
                            type: 'get',
                            success: function(data) {
                                initBOPValidateForm(anunciId, data);
                                removeLoader();
                            }
                        });
                    }
                }
            }
        });
    });

    /*
     * Modal anuncis relacionats
     */
    function initModalRelacionatsOnceLoaded()
    {
        // Datapicker únic camp
        $('.modal-relacionats .datepicker').datetimepicker({
            locale: idioma,
            format: 'DD/MM/YYYY',
            useCurrent: false
        });

        $('.modal-relacionats a:external, .modal-relacionats a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external');

        $('[data-toggle="tooltip"]').tooltip();
    }

    $('.modal-relacionats').on('loaded.bs.modal', function (e) {
        initModalRelacionatsOnceLoaded();
    });
    $(document).on('click', '.openModalRelacionats', function(e){
        e.preventDefault();
        addLoader();
        var formContainer = $($(this).data('target') + ' .modal-content');
        var modal = $(this).data('target');
        $.ajax({
            url: $(this).attr('href'),
            type: 'get',
            success: function(data) {
                formContainer.html(data);
                initModalRelacionatsOnceLoaded();
                removeLoader();
                $(modal).modal('toggle');
            }
        });

        return false;
    });
    $(document).on('submit', ".modal-relacionats form", function(e){
        e.preventDefault();
        addLoader();
        var form = $(this);
        var formContainer = $(this).closest('.modal-content');
        $.ajax({
            url: form.attr('action'),
            type: 'get',
            data: form.serialize(),
            success: function(data) {
                formContainer.html(data);
                initModalRelacionatsOnceLoaded();
                removeLoader();
            }
        });
        return false;
    });





    /*
     * Modal convocatories
     */
    function initModalConvocatoriesOnceLoaded()
    {
        $('.modal-convocatories a:external, .modal-convocatories a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external');
        $('[data-toggle="tooltip"]').tooltip();
        initConvocatroiesCollection();

    }

    $('.modal-convocatories').on('loaded.bs.modal', function (e) {
        initModalConvocatoriesOnceLoaded();
    });
    $(document).on('click', '.openModalConvocatories', function(e){
        e.preventDefault();
        addLoader();
        var formContainer = $($(this).data('target') + ' .modal-content');
        var modal = $(this).data('target');
        $.ajax({
            url: $(this).attr('href'),
            type: 'get',
            success: function(data) {
                formContainer.html(data);
                initModalConvocatoriesOnceLoaded();
                removeLoader();
                $(modal).modal('toggle');
            }
        });

        return false;
    });
    $(document).on('submit', ".modal-convocatories form", function(e){
        e.preventDefault();
        addLoader();
        var form = $(this);
        var formContainer = $(this).closest('.modal-content');
        $.ajax({
            url: form.attr('action'),
            type: 'get',
            data: form.serialize(),
            success: function(data) {
                formContainer.html(data);
                initModalConvocatoriesOnceLoaded();
                removeLoader();
            }
        });
        return false;
    });



    /*
     * Modal informació anunci original
     */
    function initModalInformacioOriginalOnceLoaded()
    {
        $('.modal-relacionats a:external, .modal-relacionats a[rel=external]').attr('target', '_blank').addClass('external').attr('rel', 'external');

        $('[data-toggle="tooltip"]').tooltip();
    }

    $('.modal-relacionats').on('loaded.bs.modal', function (e) {
        initModalInformacioOriginalOnceLoaded();
    });
    $(document).on('click', '.openModalFormOriginal', function(e){
        e.preventDefault();
        addLoader();
        var formContainer = $($(this).data('target') + ' .modal-content');
        var modal = $(this).data('target');
        $.ajax({
            url: $(this).attr('href'),
            type: 'get',
            success: function(data) {
                formContainer.html(data);
                initModalInformacioOriginalOnceLoaded();
                removeLoader();
                $(modal).modal('toggle');
            }
        });

        return false;
    });



    /*
     * Modal canvi tipus anunci
     */


    $('.btn-canvi-materia').on('loaded.bs.modal', function (e) {

    });
    $(document).on('click', '.btn-canvi-materia', function(e){
        e.preventDefault();
        addLoader();
        var formContainer = $($(this).data('target') + ' .modal-content');
        var modal = $(this).data('target');
        $.ajax({
            url: $(this).attr('href'),
            type: 'get',
            success: function(data) {
                formContainer.html(data);
                formContainer.find("select.select2").select2();
                formContainer.find("label.radio, label.checkbox").append('<span class="control-indicator"></span>');
                removeLoader();
                $(modal).modal('toggle');
            }
        });

        return false;
    });




    /*
     * Session refresh
     */

    var refreshTime = 60000; // every 1 minutes in milliseconds
    window.setInterval( function() {
        $.ajax({
            cache: false,
            type: "GET",
            url: obtenirRutaBase()+"/session-update?t=" + Math.floor(Date.now() / 1000),
            success: function(data) {
            }
        });
    }, refreshTime );

    $(document).on('input', 'textarea.titol_resum_anunci', function(e){
        if (e.originalEvent.inputType == 'insertFromPaste') {
            $(this).val($(this).val().replace(/\¿/g, "'"));
        }
    });
});
